import React from 'react';
import { Mail } from 'lucide-react';

const Footer = () => {
  const footerLinks = [
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
    { label: 'Terms', href: '/terms' },
    { label: 'Privacy', href: '/privacy' },
    { label: 'AML/KYC', href: '/compliance-policy' },
  ];

  return (
    <footer className="bg-white border-t border-gray-200 py-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo - Clickable */}
          <a href="/" className="flex items-center cursor-pointer">
            <img 
              src="https://customer-assets.emergentagent.com/job_crypto-pulse-91/artifacts/jsojo49j_Black%20%26%20White%20Elegant%20Typography%20Monogram%20Logo_20251015_202607_0000.png" 
              alt="Coinexus" 
              className="h-14 w-14 object-contain hover:opacity-80 transition-opacity duration-200"
              style={{ imageRendering: '-webkit-optimize-contrast' }}
            />
          </a>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-2 text-sm">
            {footerLinks.map((link, index) => (
              <React.Fragment key={link.label}>
                <a
                  href={link.href}
                  className="text-[#5B6B7F] hover:text-[#FF6B35] transition-colors duration-200 font-medium"
                >
                  {link.label}
                </a>
                {index < footerLinks.length - 1 && (
                  <span className="text-[#5B6B7F]">|</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Footer Content */}
        <div className="border-t border-gray-200 pt-5 mt-6">
          <div className="text-center space-y-2">
            <p className="text-[#5B6B7F] text-xs">
              © 2025 Coinexus. All rights reserved.
            </p>
            <div className="flex items-center justify-center gap-2 text-xs">
              <Mail className="h-3.5 w-3.5 text-[#FF6B35]" />
              <a href="mailto:info@coinexus.vip" className="text-[#1E3A5F] hover:text-[#FF6B35] font-semibold transition-colors">
                info@coinexus.vip
              </a>
            </div>
            <p className="text-[#5A6B7A] text-[10px] font-medium">
              COINEXUS Sp. z o.o. — KRS 0001142506 | NIP 7252350358 | REGON 540348512
            </p>
            <p className="text-[#5A6B7A] text-[10px]">
              Registered office: Juliana Tuwima 48, unit 11, 90-021 Łódź, Poland
            </p>
            <p className="text-[#5A6B7A] text-[10px]">
              Licensed Virtual Asset Service Provider (VASP) — License number RDWW-1750
            </p>
            <p className="text-[#5A6B7A] text-[10px]">
              Supervised by the Polish Financial Intelligence Unit (GIIF)
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;